{
	"title": "Transactions in reconciliation",
	"filterByLabel": "Filter by",
	"filterByPlaceholder": "Select filter",
	"filterOptions": {
		"paymentMethod": "Payment Method",
		"paymentMethodCredit": "Credit",
		"paymentMethodDebit": "Debit",
		"vendor": "Vendor",
		"status": "Status"
	},
	"searchPlaceholder": "Search for...",
	"columns": {
		"transactionDate": "TRANSACTION DATE",
		"paymentMethod": "PAYMENT METHOD",
		"vendor": "VENDOR",
		"terminalNumber": "TERMINAL NO.",
		"status": "STATUS",
		"value": "VALUE",
		"receipt": "RECEIPT"
	},
	"statusPending": "PENDING",
	"statusProcessed": "PROCESSED",
	"statusReconciled": "RECONCILED",
	"statusCancelled": "CANCELLED",
	"statusTooltipPaid": "Transaction already paid to the acquirer",
	"receiptTooltipView": "View receipt",
	"receiptTooltipUnavailable": "Receipt unavailable",
	"of": "of",
	"backButton": "Back"
}
